# Content localisation

The SEEK API now supports language localisation in select GraphQL operations and SEEK-hosted panels.
Propagate the [`Accept-Language`] header in a [GraphQL request] to retrieve translated content and error messages for display to the end user.

See the [content localisation] section in our GraphQL documentation for more information.

[`accept-language`]: https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Accept-Language
[content localisation]: /graphql/in-practice#content-localisation
[graphql request]: /graphql#requests-and-responses
